import { render, staticRenderFns } from "./Contactcustomer.vue?vue&type=template&id=3f862c84&scoped=true"
import script from "./Contactcustomer.vue?vue&type=script&lang=js"
export * from "./Contactcustomer.vue?vue&type=script&lang=js"
import style0 from "./Contactcustomer.vue?vue&type=style&index=0&id=3f862c84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f862c84",
  null
  
)

export default component.exports